/* 🤖 this file was generated by script */
export const wiconArrowCircleRight = {
  name: 'arrow_circle_right',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 16l4-4m0 0l-4-4m4 4H8m14 0a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
